import React, { useState } from 'react'
import { IconButton, makeStyles } from '@material-ui/core'
import { GRAY_COLORS } from 'asterX-UI'
import { EyeIcon, EyeOffIcon } from 'asterX-UI/Icons'

const useStyle = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: 7
  },
  text: {
    color: GRAY_COLORS[500],
    fontSize: 14,
    fontWeight: 500,
    lineHeight: '18px'
  }
}))

const PhoneView = ({ phone = '', assignTo }) => {
  const classes = useStyle()

  const [isShow, setIsShow] = useState(false)
  const formattedPhone = phone
  const text = phone
    ? isShow
      ? formattedPhone
      : formattedPhone.slice(0, 3) + '-XXX-XX-' + formattedPhone.slice(-3) // Mask the middle part
    : '-'
  console.log('assignTo', assignTo)
  return (
    <div className={classes.root}>
      <a
        className={classes.text}
        type={'phone'}
        {...(isShow && phone
          ? {
              target: '_blank',
              href: 'tel:' + formattedPhone
            }
          : {})}
      >
        {text}
      </a>
      {phone && (
        <IconButton
          disabled={assignTo === null ? true : false}
          size={'small'}
          onClick={() => setIsShow(!isShow)}
        >
          {isShow ? (
            <EyeOffIcon
              style={{
                color: GRAY_COLORS[500],
                fontSize: 16
              }}
            />
          ) : (
            <EyeIcon
              style={{
                color: GRAY_COLORS[500],
                fontSize: 16
              }}
            />
          )}
        </IconButton>
      )}
    </div>
  )
}
export default PhoneView
